import React, { useMemo, useEffect } from "react";
import { Link } from "react-router-dom";
import "./NewsandEvents.css";
import newsEntries from "./newsData";

const NewsandEvents = () => {
  // Sort news entries by date (most recent first)
  const sortedNewsEntries = useMemo(() => {
    return [...newsEntries].sort((a, b) => {
      // Parse dates (format: "Month Day, Year" e.g., "July 13, 2025")
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      // Sort descending (most recent first)
      return dateB - dateA;
    });
  }, []);

  const highlight = sortedNewsEntries[0];

  // Preload featured news image immediately for instant display
  useEffect(() => {
    if (highlight && highlight.image) {
      const img = new Image();
      img.src = highlight.image;
      if (img.decode) {
        img.decode().catch(() => {});
      }
    }
  }, [highlight]);

  return (
    <div className="news-events-page">
      <section className="news-hero">
        <p className="eyebrow">News & Events</p>
        <h1>Moments that shape the Vardaan story</h1>
      </section>

      <section className="news-content">
        <aside className="news-highlight">
          {highlight && (
            <div className="highlight-card">
              <p className="highlight-label">Spotlight</p>
              <h3>{highlight.title}</h3>
              <p className="highlight-summary">{highlight.summary}</p>
              <div className="highlight-meta">
                <span>📅 {highlight.date}</span>
                <span className="highlight-tag">{highlight.category}</span>
              </div>
            </div>
          )}
        </aside>

        <div className="news-feed">
          {sortedNewsEntries.map((item) => (
            <article className="news-feed__item" key={item.id}>
              <Link to={`/news-events/${item.slug}`} className="feed-card">
                <div
                  className={`feed-card__media ${
                    item.mediaFit === "contain" ? "feed-card__media--contain" : ""
                  }`}
                >
                  <img 
                    src={item.image} 
                    alt={item.title} 
                    loading={item.id === highlight?.id ? "eager" : "lazy"}
                    fetchPriority={item.id === highlight?.id ? "high" : "auto"}
                    decoding="async"
                  />
                  <span className="feed-tag">{item.category}</span>
                </div>

                <div className="feed-card__body">
                  <h2>{item.title}</h2>
                  <p className="feed-summary">{item.summary}</p>
                  <div className="feed-meta">
                    <span>📅 {item.date}</span>
                  </div>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
};

export default NewsandEvents;
